<template>
    <!-- // ***************** CHECK LIST ************************ -->
    <v-container grid-list-md fluid>
        <v-row class="d-flex justify-space-between mb-1">
            <v-col cols="6" class="d-flex flex-column">
                <v-row no-gutters class="d-flex align-center">
                    <v-col cols="1" class="d-flex align-center justify-center">
                        <v-btn-back @click="$router.push({ name: 'auditReport' })" />
                    </v-col>
                    <v-col cols="11">
                        <h2>Emprunts</h2>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="1" />
                    <v-col cols="10">
                        {{ `Statut : ${checkStatus}` }}
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="6">
                <v-row no-gutters class="d-flex justify-end align-center">
                    <!-- ** upload -->
                    <v-tooltip location="bottom" text="Lier un document">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                @click="dialogAuditCheckDocumentsManager = true"
                                v-bind="props"
                                size="x-small"
                                icon="$oss-upload"
                                class="mx-1"
                            />
                        </template>
                    </v-tooltip>

                    <!-- ** chat -->
                    <v-tooltip location="bottom" text="Message">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                @click="openChat = !openChat"
                                v-bind="props"
                                size="x-small"
                                icon="$oss-chat"
                                class="mx-1"
                            />
                        </template>
                    </v-tooltip>

                    <!-- ** store -->
                    <v-btn
                        :disabled="
                            closedPeriod || validated || loading || dataLoading || !accountingPeriod
                        "
                        @click="validateAudit()"
                        size="small"
                        class="mx-1"
                        rounded="xl"
                    >
                        Enregistrer
                    </v-btn>

                    <!-- ** validate -->
                    <v-btn
                        :disabled="closedPeriod || loading || dataLoading || !accountingPeriod"
                        @click="validateFunction()"
                        size="small"
                        class="mx-1"
                        rounded="xl"
                    >
                        {{ validated ? "Invalider" : "Valider" }}
                    </v-btn>

                    <template v-if="isEnableReview">
                        <div
                            style="
                                border-right: 2px solid black;
                                width: 2px;
                                height: 25px;
                                margin: 0 4px;
                            "
                        />

                        <v-icon
                            :disabled="
                                reviewed === 1 ||
                                !isEnableReview ||
                                !validated ||
                                loading ||
                                dataLoading
                            "
                            size="small"
                            icon="$fa-thumbs-up"
                            color="primary"
                            class="mx-1"
                            @click="
                                reviewed = 1;
                                validateAudit('REVIEW');
                            "
                        />

                        <v-icon
                            :disabled="
                                reviewed === -1 ||
                                !isEnableReview ||
                                !validated ||
                                loading ||
                                dataLoading
                            "
                            size="small"
                            icon="$fa-thumbs-down"
                            color="primary"
                            class="mx-1"
                            @click="
                                reviewed = -1;
                                validateAudit('REVIEW');
                            "
                        />

                        <div
                            style="
                                border-right: 2px solid black;
                                width: 1px;
                                height: 25px;
                                margin: 0 4px;
                            "
                        />
                    </template>

                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-prev
                                v-bind="props"
                                :disabled="!previousControl"
                                @click="
                                    reviewed = 0;
                                    openChat = false;
                                    goToPreviousControl();
                                "
                            />
                        </template>
                        <div style="width: 400px" class="d-flex justify-center">
                            Contrôle précédent :
                            {{
                                previousControl && previousControl.title
                                    ? previousControl.title
                                    : ""
                            }}
                        </div>
                    </v-tooltip>

                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-next
                                v-bind="props"
                                @click="
                                    reviewed = 0;
                                    openChat = false;
                                    goToNextControl();
                                "
                                :disabled="!nextControl"
                            >
                            </v-btn-next>
                        </template>

                        <div style="width: 400px" class="d-flex justify-center">
                            Contrôle suivant :
                            {{ nextControl && nextControl.title ? nextControl.title : "" }}
                        </div>
                    </v-tooltip>

                    <div
                        style="
                            border-right: 2px solid black;
                            width: 1px;
                            height: 25px;
                            margin: 0 4px;
                            color:'{{secondary}}'
                        "
                    />

                    <v-menu offset-y>
                        <template v-slot:activator="{ props }">
                            <v-btn-icon
                                icon="$dots_vertical"
                                v-bind="props"
                                class="mx-1"
                                color="secondary"
                            />
                        </template>

                        <v-list nav>
                            <v-list-item
                                @click="displayActivityDialog = true"
                                :title="`Afficher l'activité`"
                            >
                                <template #append>
                                    <v-icon>$oss-activity</v-icon>
                                </template>
                            </v-list-item>

                            <template v-if="!showDeleteAcrBtnIfRecovery">
                                <v-tooltip location="bottom">
                                    <template v-slot:activator="{ props }">
                                        <div no-gutters v-bind="props">
                                            <v-list-item no-gutters disabled>
                                                <v-list-item-title>
                                                    Supprimer le contrôle
                                                </v-list-item-title>

                                                <template v-slot:append>
                                                    <v-icon size="small"> $oss-trash </v-icon>
                                                </template>
                                            </v-list-item>
                                        </div>
                                    </template>
                                    <span>{{ showDeleteAcrBtnTooltipMessage }}</span>
                                </v-tooltip>
                            </template>

                            <!-- ** without tooltip -->
                            <template v-else>
                                <v-list-item
                                    no-gutters
                                    @click="deleteAuditCheckResultDialog = true"
                                >
                                    <v-list-item-title> Supprimer le contrôle </v-list-item-title>

                                    <template v-slot:append>
                                        <v-icon>$oss-trash</v-icon>
                                    </template>
                                </v-list-item>
                            </template>
                        </v-list>
                    </v-menu>
                </v-row>
            </v-col>
        </v-row>
        <div
            style="
                height: calc(100vh - 157px);
                overflow-y: auto;
                border-top-left-radius: 25px;
                border-top-right-radius: 25px;
            "
        >
            <!-- // * loading -->
            <template v-if="loading || dataLoading">
                <v-card
                    elevation="0"
                    style="background-color: #ffffff; border-radius: 25px; margin-top: 10px"
                >
                    <v-card-title class="pa-4 d-flex justify-center">
                        <v-progress-circular indeterminate class="mr-3" />
                    </v-card-title>
                </v-card>
            </template>

            <template v-else-if="!accountingPeriod">
                <v-row no-gutters class="d-flex flex-column justify-center align-center mb-3">
                    <v-icon class="mr-2 mb-1" size="large"> $oss-warning </v-icon>
                    <h3>Aucune période sélectionnée</h3>
                </v-row>
            </template>

            <template v-else>
                <!-- // +++++++++++? warning if accountingPeriod.closed -->
                <v-row
                    no-gutters
                    v-if="closedPeriod"
                    class="d-flex flex-column justify-center align-center mb-3"
                >
                    <v-icon class="mr-2 mb-1" size="large"> $oss-warning </v-icon>
                    <h3>Période clôturée</h3>
                </v-row>
                <h2 class="my-3 ml-2">Tableau récapitulatif</h2>
                <v-data-table
                    title
                    :headers="headers"
                    :items="auditItems"
                    :items-per-page="-1"
                    hide-default-footer
                    rounded="xl"
                    class="table"
                >
                    <template v-slot:item="props">
                        <tr :acKey="props.item.index">
                            <td width="5%" />
                            <td width="30%" class="text-center">
                                {{ props.item.aaName }} - {{ props.item.aaDescription }}
                            </td>
                            <td width="10%" class="text-center">
                                {{
                                    newCommonFormatCurrency(props.item.totalDebit, { currency: "" })
                                }}
                            </td>
                            <td width="10%" class="text-center">
                                {{
                                    newCommonFormatCurrency(props.item.totalCredit, {
                                        currency: "",
                                    })
                                }}
                            </td>
                            <td width="20%" class="text-center">
                                <oss-text-field
                                    outlined
                                    v-model="props.item.officialBalance"
                                    dense
                                    hide-details
                                    :disabled="validated"
                                />
                            </td>
                            <td width="10%" class="text-center">
                                {{ newCommonFormatCurrency(props.item.delta, { currency: "" }) }}
                            </td>
                            <td width="10%">
                                <div class="d-flex justify-center">
                                    <v-btn
                                        :disabled="
                                            !props.item.toAdjust || validated || closedPeriod
                                        "
                                        rounded
                                        class="btn btn_blue"
                                        @click="
                                            createRows(props.item.aaName, props.item.delta);
                                            toggleMiscellaneousOperationDialog();
                                        "
                                        size="small"
                                    >
                                        OD
                                    </v-btn>
                                </div>
                            </td>
                            <td width="5%" />
                        </tr>
                    </template>
                </v-data-table>
                <v-card
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row>
                        <v-col cols="11" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <v-row no-gutters class="d-flex align-center">
                                    <v-col cols="2">
                                        <h5 class="pl-4">Extrait du grand livre</h5>
                                    </v-col>
                                    <v-spacer />
                                    <v-col cols="4">
                                        <v-select-filled
                                            v-model="glAccountingPeriod"
                                            :items="accountingPeriodsList"
                                            item-title="text"
                                            label="Exercice"
                                            :disabled="
                                                !generalLedgerExpand ||
                                                !accountingPeriodsList.length ||
                                                accountingPeriodsList.length === 1
                                            "
                                            hide-details
                                            inset
                                            outlined
                                            density="compact"
                                        />
                                    </v-col>
                                    <v-spacer />
                                    <v-col cols="4">
                                        <v-combobox-filled
                                            v-model="accountableAccountsRoot"
                                            label="Racines comptes"
                                            multiple
                                            outlined
                                            hide-details
                                            dense
                                            chips
                                            deletable-chips
                                            item-disabled
                                            :disabled="
                                                !generalLedgerExpand ||
                                                !accountingPeriodsList.length ||
                                                accountingPeriodsList.length === 1
                                            "
                                            clearable
                                        />
                                    </v-col>
                                    <v-spacer />
                                    <v-col cols="1">
                                        <v-switch
                                            v-model="showNm1"
                                            label="N-1"
                                            hide-details
                                            :disabled="
                                                !generalLedgerExpand ||
                                                !accountingPeriodsList.length ||
                                                accountingPeriodsList.length === 1
                                            "
                                            class="pl-2 mt-0"
                                        />
                                    </v-col>
                                </v-row>
                            </v-card-title>
                        </v-col>
                        <v-spacer />
                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row>
                                <v-col cols="6" class="align-center pa-0"> </v-col>
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            generalLedgerExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        "
                                        @click="generalLedgerExpand = !generalLedgerExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-card-text v-show="generalLedgerExpand" transition="expand">
                        <v-card elevation="0">
                            <v-row>
                                <v-col cols="12">
                                    <GeneralLedger
                                        ref="generalLedger"
                                        :companyId="companyId"
                                        :accountingPeriodId="glAccountingPeriod"
                                        :accountableAccountFilter="glAccountableAccountsRoot"
                                        :hideOptions="hideOptions"
                                        :inThirdParty="showThirdParty"
                                        @thirdPartyChanged="showThirdParty = !showThirdParty"
                                        :inNm1="showNm1"
                                        @nm1Changed="showNm1 = !showNm1"
                                        :enableAuditedAccountableAccounts="
                                            glAccountingPeriod === accountingPeriodId
                                        "
                                    >
                                    </GeneralLedger>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-card-text>
                </v-card>

                <!-- // ** Documents -->
                <template v-if="!loading && !dataLoading">
                    <AuditConnectedAcrDocuments
                        :connectedDocuments="connectedDocuments"
                        :companyId="companyId"
                        :acKey="acKey"
                        :auditCheckResult="auditCheckResult || {}"
                        :accountingPeriodId="accountingPeriodId || undefined"
                        @unlinkedDocument="unlinkDocument($event)"
                        @showLinkedDocument="showLinkedDocument($event)"
                    />
                </template>

                <!-- // ** results -->
                <template v-if="!loading && !dataLoading">
                    <AuditConnectedAcrResults :results="results" :companyId="companyId" />
                </template>

                <v-card
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row>
                        <v-col cols="5" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">Commentaires détaillés</h5>
                            </v-card-title>
                        </v-col>
                        <v-spacer />
                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row>
                                <v-col cols="6" class="align-center pa-0"> </v-col>
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            commentExpand ? '$fa-chevron-up' : '$fa-chevron-down'
                                        "
                                        @click="commentExpand = !commentExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-card-text v-if="commentExpand" transition="expand">
                        <v-row class="pt-6">
                            <v-col style="padding-top: 0">
                                <v-card-text style="padding: 0">
                                    <v-textarea
                                        v-model="comment"
                                        :disabled="closedPeriod || validated"
                                        auto-grow
                                        style="height: auto; border: 1px #ededed solid"
                                        outlined
                                    />
                                </v-card-text>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <v-card
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row>
                        <v-col cols="5" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">Commentaires synthétiques</h5>
                            </v-card-title>
                        </v-col>
                        <v-spacer />
                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row>
                                <v-col cols="6" class="align-center pa-0"> </v-col>
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            shortCommentExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        "
                                        @click="shortCommentExpand = !shortCommentExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-card-text v-if="shortCommentExpand" transition="expand">
                        <v-row class="pt-6">
                            <v-col style="padding-top: 0">
                                <v-card-text style="padding: 0">
                                    <v-textarea
                                        v-model="shortComment"
                                        :disabled="closedPeriod || validated"
                                        auto-grow
                                        style="height: auto; border: 1px #ededed solid"
                                        outlined
                                    />
                                </v-card-text>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <!-- ++ deleteAuditCheckResultDialog -->
                <template v-if="deleteAuditCheckResultDialog">
                    <AuditDeleteAuditCheckResultDialog
                        v-model="deleteAuditCheckResultDialog"
                        :auditCheckResultId="auditCheckResult.id"
                        @closed="
                            deleteAuditCheckResultLoading = false;
                            deleteAuditCheckResultDialog = false;
                        "
                        @deletedAcr="deleteAcrDone"
                    />
                </template>

                <oss-dialog
                    v-model="miscellaneousOperationDialog"
                    :actions="actionsMiscellaneousOperation"
                    min-width="90vw"
                >
                    <AccountingItemEdition2
                        v-if="miscellaneousOperationDialog"
                        :companyId="companyId"
                        :prefilledRows="miscellanousOperationData"
                        :acKey="acKey"
                        :auditCheckResult="auditCheckResult"
                        :accountingPeriodId="accountingPeriodId"
                        :actions="actionsMiscellaneousOperation"
                        @upsert="onODUpserted($event)"
                    />
                </oss-dialog>

                <!-- <AccountingItemEdition
                    v-model="miscellaneousOperationDialog"
                    :companyId="companyId"
                    :prefilledRows="miscellanousOperationData"

                    :acKey="acKey"
                    :auditCheckResult="auditCheckResult"
                    :accountingPeriodId="accountingPeriodId"
                    @upsert="refresh()"
                    v-if="miscellaneousOperationDialog"
                ></AccountingItemEdition> -->
                <Chat
                    :auditCheckAccountingPeriodKey="chatId"
                    v-if="openChat"
                    v-bind:chatTitle="'Chat'"
                />
                <AuditCheckDocumentsManager
                    v-model="dialogAuditCheckDocumentsManager"
                    v-if="dialogAuditCheckDocumentsManager"
                    :disabled="loading || dataLoading || !accountingPeriod"
                    :companyId="companyId"
                    :documentToDisplay="documentToDisplay"
                    :connectedDocuments="connectedDocuments || []"
                    :acKey="acKey"
                    :auditCheckResult="auditCheckResult || {}"
                    :accountingPeriodId="accountingPeriodId || undefined"
                    :alreadyLinkedDoc="alreadyLinkedDoc"
                    @upsertedAuditCheckResult="upsertedACR"
                    @resetDialogData="
                        alreadyLinkedDoc = false;
                        documentToDisplay = {};
                    "
                />
                <oss-dialog
                    v-model="displayActivityDialog"
                    v-if="displayActivityDialog"
                    title="Activité"
                    valid-title="Fermer"
                    @valid="displayActivityDialog = false"
                    @close="displayActivityDialog = false"
                    min-width="60vw"
                >
                    <UsersActivitiesHistory
                        :auditCheckKey="acKey"
                        :accountingPeriodId="accountingPeriodId"
                    >
                    </UsersActivitiesHistory>
                </oss-dialog>
                <oss-dialog
                    v-if="warningDialog"
                    v-model="warningDialog"
                    title="Attention"
                    @valid="
                        validated = !validated;
                        validateAudit('VALIDATE');
                        toggleWarningDialog();
                    "
                    @close="warningDialog = false"
                    min-width="800px"
                >
                    <h4 class="text-center">
                        Il reste un écart sur un compte, souhaitez-vous vraiment valider ce contrôle
                        ?
                    </h4>
                </oss-dialog>
            </template>
        </div>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { Apollo } from "@/decorators";

import { mathFix } from "../../services/mathServices";
import { closedPeriod, formatConnectedDocuments } from "../../services/audit/AuditServices";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";

import GeneralLedger from "../GeneralLedger2.vue";
import { CheckBase } from "./CheckBase";
import AccountingItemEdition2 from "../accounting/accountingItem/Edition.vue";
import AuditCheckDocumentsManager from "./AuditCheckDocumentsManager.vue";
import AuditConnectedAcrDocuments from "./AuditConnectedAcrDocuments.vue";
import AuditConnectedAcrResults from "./AuditConnectedAcrResults.vue";
import UsersActivitiesHistory from "../UsersActivitiesHistory.vue";
import AuditDeleteAuditCheckResultDialog from "./AuditDeleteAuditCheckResultDialog.vue";
import Chat from "../chat/Chat.vue";

import AUDIT_ITEMS from "../../graphql/audit/AuditItems.gql";
import UPSERT_AUDIT_CHECK_RESULT from "../../graphql/audit/UpsertAuditCheckResultClosure.gql";
import { DialogAction } from "@/services/dialogAction";
import { Component, Vue, toNative } from "vue-facing-decorator";

class LoanAnalyse {
    aaName: string;
    aaDescription: string;
    totalDebit: number;
    totalCredit: number;
    officialBalance: number;

    constructor(
        aaName: string,
        aaDescription: string,
        totalDebit: number,
        totalCredit: number,
        officialBalance: number,
    ) {
        this.aaName = aaName || "";
        this.aaDescription = aaDescription || "";
        this.totalDebit = totalDebit || 0;
        this.totalCredit = totalCredit || 0;
        this.officialBalance = officialBalance || 0;
    }

    get accountingBalance() {
        return this.totalDebit - this.totalCredit;
    }

    get amountToDisplay() {
        if (this.accountingBalance < 0) {
            return this.accountingBalance * -1;
        }
        return this.accountingBalance;
    }

    get delta() {
        if (
            this.accountingBalance !== undefined &&
            this.accountingBalance !== null &&
            this.officialBalance !== undefined &&
            this.officialBalance !== null
        ) {
            return mathFix(this.amountToDisplay - this.officialBalance);
        }
        return 0;
    }

    get toAdjust() {
        return this.delta !== 0;
    }
}

@Component({
    components: {
        GeneralLedger,
        AuditCheckDocumentsManager,
        AuditConnectedAcrDocuments,
        AuditConnectedAcrResults,
        Chat,
        UsersActivitiesHistory,
        AuditDeleteAuditCheckResultDialog,
        AccountingItemEdition2,
    },
})
export class CheckBankLoansAuto extends CheckBase {
    loading: boolean = false;
    dataLoading: boolean = true;
    deleteAuditCheckResultLoading: boolean = false;

    company: any = {};
    companyTaxSystem: string = "";
    companyVatSystem: string = "";

    auditCheckResult: any = null;

    validated: boolean = false;
    miscellaneousOperationDialog: boolean = false;

    comment: string = "";
    commentExpand: boolean = false;

    shortComment: string = "";
    shortCommentExpand: boolean = false;

    showDeleteAcrBtnTooltipMessage: string = "";

    miscellanousOperationData: Array<any> = [];

    generalLedgerExpand: boolean = false;
    hideOptions: boolean = true;
    showThirdParty: boolean = false;
    showNm1: boolean = false;

    warningDialog: boolean = false;
    deleteAuditCheckResultDialog: boolean = false;

    dialogAuditCheckDocumentsManager: boolean = false;

    documentToDisplay: any = {};
    // documents: Array<any> = [] // ** in ACRs gql, documents is used to create
    connectedDocuments: Array<any> = [];
    results: Array<any> = [];

    alreadyLinkedDoc: boolean = false;

    actionsMiscellaneousOperation = {
        action: new DialogAction(),
    };

    toggleWarningDialog() {
        this.warningDialog = !this.warningDialog;
    }

    get documentsHeaders() {
        const headers = [
            { title: "Nom", value: "name", align: "left" },
            // { title: 'Compte Comptable', value: 'accountableAccount', align: 'start' },
            { title: "Type", value: "type", align: "left" },
            { title: "Statut", value: "status", align: "left" },
            { title: "Action", value: "action", align: "right" },
        ];
        return headers;
    }

    headers = [
        {
            title: "",
            sortable: false,
            align: "center",
            class: "subtitle-2",
        },
        {
            title: "Compte",
            sortable: false,
            align: "center",
            class: "subtitle-2",
        },
        {
            title: "Solde débit",
            sortable: false,
            align: "center",
            class: "subtitle-2",
        },
        {
            title: "Solde crédit",
            sortable: false,
            align: "center",
            class: "subtitle-2",
        },
        {
            title: "Capital restant dû",
            sortable: false,
            align: "center",
            class: "subtitle-2",
        },
        {
            title: "Ecart",
            sortable: false,
            align: "center",
            class: "subtitle-2",
        },
        {
            title: "Ajuster",
            sortable: false,
            align: "center",
            class: "subtitle-2",
        },
        {
            title: "",
            sortable: false,
            align: "center",
            class: "subtitle-2",
        },
    ];

    get warnBeforeValid() {
        for (const item of this.auditItems) {
            if (item.delta !== 0) {
                return true;
            }
        }
        return false;
    }

    get checkStatus() {
        if (this.validated && this.reviewed === 1) {
            return "Validé par le responsable";
        }
        if (this.validated && this.reviewed === -1) {
            return "Refusé par le responsable";
        }
        if (this.validated && this.reviewed === 0) {
            return "En attente de validation par le responsable";
        }
        if (!this.validated && !this.auditCheckResult) {
            return "A faire";
        }
        if (!this.validated && this.auditCheckResult) {
            return "En cours";
        }
        return "statut manquant";
    }

    get showDeleteAcrBtnIfRecovery() {
        if (this.auditCheckResult?.id) {
            if (this.closedPeriod) {
                this.showDeleteAcrBtnTooltipMessage = "Exercice N clôturé";
                return false;
            }
            return true;
        }
        this.showDeleteAcrBtnTooltipMessage = "Aucun contrôle";
        return false;
    }

    toggleMiscellaneousOperationDialog() {
        this.miscellaneousOperationDialog = !this.miscellaneousOperationDialog;
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    beforeMount() {
        this._mounted();
        this.searchAccountingPeriod();
        window.scrollTo(0, 0);
    }

    createRows(aaName, amount) {
        amount = mathFix(amount);
        const wording = "Ajustement " + moment(this.accountingPeriod.end).format("DD/MM/YYYY");
        this.miscellanousOperationData = [];

        const mainRow = {
            date: this.accountingPeriod.end,
            dueDate: "",
            accountableAccount: { name: aaName },
            wording,
            netAmount: amount,
            debit: amount > 0 ? Math.abs(amount) : 0.0,
            credit: amount < 0 ? Math.abs(amount) : 0.0,
        };

        const secondRow = {
            date: this.accountingPeriod.end,
            accountableAccount: { name: "" },
            wording,
            netAmount: 0.0,
            debit: 0.0,
            credit: 0.0,
        };

        this.miscellanousOperationData.push(JSON.parse(JSON.stringify(mainRow)));

        this.miscellanousOperationData.push(JSON.parse(JSON.stringify(secondRow)));
    }

    // ***********************************************************
    // ********** APOLLO - AUDIT_ITEMS ***************************
    @Apollo({
        query: AUDIT_ITEMS,
        variables() {
            return {
                companyId: this.companyId,
                auditCheckKey: this.acKey,
                accountingPeriodId: this.accountingPeriodId || undefined,
            };
        },
        skip() {
            return !this.companyId || !this.accountingPeriodId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                this.dataLoading = true;
                this.deleteAuditCheckResultDialog = false;
                this.deleteAuditCheckResultLoading = false;

                this.accountableAccountsRoot =
                    data.auditItems?.items?.[0]?.accountableAccountsRoot || [];

                if (data?.auditItems?.items[0]?.auditCheckResult?.[0]) {
                    this.auditCheckResult = data?.auditItems?.items[0].auditCheckResult[0];

                    this.auditCheckResultId = this.auditCheckResult.id;

                    if (this.auditCheckResult.reviewed) {
                        this.reviewed = this.auditCheckResult.reviewed;
                    }

                    if (this.auditCheckResult.documents) {
                        this.connectedDocuments = this.auditCheckResult.documents;
                    }

                    if (this.auditCheckResult.results) {
                        this.results = this.auditCheckResult.results;
                    }

                    if (this.auditCheckResult?.data?.global) {
                        this.validated = this.auditCheckResult.data.global.validated || false;
                        this.comment = this.auditCheckResult.data.global.comment || "";
                        this.shortComment = this.auditCheckResult.data.global.shortComment || "";
                    }

                    if (this.auditCheckResult?.data[0]?.details?.length) {
                        this.acrDetails = this.auditCheckResult.data[0].details;
                    }
                }
                if (data?.auditItems?.items?.[0]) {
                    const items = [];
                    for (const item of data.auditItems.items[0].accountableAccounts) {
                        let officialBalance = null;
                        if (this.auditCheckResult?.data?.details) {
                            const previousAcr = this.auditCheckResult.data.details.find(
                                (acr) => acr.accountableAccount === item.name,
                            );
                            officialBalance = previousAcr ? previousAcr.officialBalance : null;
                        }
                        const loanToAnalyse = new LoanAnalyse(
                            item.name,
                            item.description,
                            item.totalDebit,
                            item.totalCredit,
                            officialBalance,
                        );
                        items.push(loanToAnalyse);
                    }
                    this.auditItems = items;
                }
                this.dataLoading = false;
            }
        },
    })
    auditItems: Array<any> = [];

    accountableAccountsRoot: Array<any> = [];

    auditCheckKey: string = "";

    accountableAccounts: Array<any> = [];

    auditCheckResultId: string = "";

    acrDetails: Array<any> = [];

    reviewed: number = 0;

    async validateAudit(action = undefined, results = undefined) {
        // const documentIds: Array<any> = []
        // if (data) {
        //     if (data.output?.documents?.length) {
        //         if (data.output.documents.length === 1 && data.output.documents[0].outputId) {
        //             documentIds.push({id: data.output.documents[0].outputId})
        //         } else {
        //             for (const doc of data.output.documents) {
        //                 if (doc.outputId) {
        //                     documentIds.push({id: doc.outputId})
        //                 }
        //             }
        //         }
        //     }
        // }

        // let connectedDocumentIds: Array<any> = []
        // if (this.connectedDocuments.length) {
        //     connectedDocumentIds = this.connectedDocuments.map(doc => ({id: doc.id}))
        // }

        // let connectedResultIds: Array<any> = []
        // if (this.results.length) {
        //     connectedResultIds = this.results.map((result: any) => ({id: result.id}))
        // }

        const acrData = {
            global: {
                shortComment: this.shortComment,
                comment: this.comment,
                validated: this.validated,
            },
            details: [],
        };

        const details = [];

        if (this.auditItems.length) {
            for (const item of this.auditItems) {
                // if (item.officialBalance) {
                details.push({
                    accountableAccount: item.aaName,
                    officialBalance: item.officialBalance,
                    accountingBalance: item.accountingBalance,
                    gap: item.delta,
                });
                // }
            }
            acrData.details = details;
        }

        const connectOdsToResults = this.results.map(({ id }) => ({ id }));
        if (results?.output?.documents?.[0]) {
            connectOdsToResults.push({ id: results.output.documents[0] });
        }

        if (this.acKey && this.companyId && this.accountingPeriodId) {
            const auditCheckResultVariables = {
                id: this.auditCheckResultId ? this.auditCheckResultId : "",
                key: this.acKey + "_" + this.companyId + "_" + this.accountingPeriodId,
                companyId: this.companyId,
                status: this.validated ? "VALIDATED" : "EDITION",
                accountingPeriodCreate: this.accountingPeriodId
                    ? { connect: { id: this.accountingPeriodId } }
                    : undefined,
                accountingPeriodUpdate: this.accountingPeriodId
                    ? { connect: { id: this.accountingPeriodId } }
                    : undefined,
                data: JSON.parse(JSON.stringify(acrData)),
                // deleteDocuments: [], // ** previous results, if to delete
                // documents: [],  // ** results = générés par le contrôle
                connectDocuments: formatConnectedDocuments(this.connectedDocuments), // ** docs liés
                connectOdsToResults: connectOdsToResults.length ? connectOdsToResults : undefined,
                auditCheckKey: this.acKey,
                type: "IN_AUDIT_REPORT",
                reviewed: this.reviewed,
            };

            await this.$apollo.mutate({
                mutation: UPSERT_AUDIT_CHECK_RESULT,
                variables: auditCheckResultVariables,
            });
        }

        // await this.createUserActivity(action) // deprecated

        // ++++++++++++++ RESET +++++++++++++++++++
        this.refresh();
    }

    async onODUpserted(results) {
        this.miscellaneousOperationDialog = false;
        await this.validateAudit(undefined, results);
    }

    deleteAcrDone() {
        this.deleteAuditCheckResultLoading = false;
        this.deleteAuditCheckResultDialog = false;
        this.refresh();
    }

    refresh() {
        // ++ pass through after $emit upsertedAuditCheckResult in Manager
        if (this.$apollo.queries && this.$apollo.queries.auditItems) {
            this.$apollo.queries.auditItems.refetch();
        } else {
            debugger; // git-ignore
        }

        this.initialiseCompany();
    }

    upsertedACR() {
        this.refresh();
    }

    unlinkDocument(id) {
        this.connectedDocuments = this.connectedDocuments.filter((document) => document.id !== id);
    }

    showLinkedDocument(id) {
        this.documentToDisplay = { id };
        this.alreadyLinkedDoc = true;
        this.dialogAuditCheckDocumentsManager = true;
    }

    refreshData() {
        this.$apollo.queries.auditItems.refetch();
    }

    async validateFunction() {
        if (!this.validated) {
            if (this.warnBeforeValid) {
                this.toggleWarningDialog();
            } else {
                this.validated = !this.validated;
                await this.generalLedger.setAllAccountableAccountsAsAudited();
                await this.validateAudit("VALIDATE");
            }
        } else {
            this.validated = !this.validated;
            this.reviewed = 0;
            await this.generalLedger.setAllAccountableAccountsAsUnaudited();
            await this.validateAudit("UPDATE");
        }
    }

    get closedPeriod() {
        if (this.accountingPeriod) {
            return closedPeriod(this.accountingPeriod);
        }
    }

    initialiseCompany() {
        this.company = {};
        this.companyTaxSystem = "";
        this.companyVatSystem = "";
        this.comment = "";
    }
}

export default toNative(CheckBankLoansAuto);
</script>
